export var Object3DType;
(function (Object3DType) {
    Object3DType["OBJECT_UI"] = "object_ui";
    Object3DType["CANVAS_OBJECT"] = "canvas-object";
})(Object3DType || (Object3DType = {}));
